import { jsx as _jsx } from "react/jsx-runtime";
import '@/styles/Characters/InlineEditField.css';
import { useEffect, useRef, useState } from 'react';
import MarkdownEditor from '@/components/Common/MarkdownEditor';
import MarkdownRenderer from '@/components/Common/MarkdownRenderer';
const InlineEditField = ({ value, name, type = 'text', placeholder, min, onChange, onClick, className, readOnly, }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    useEffect(() => {
        if (editing && inputRef.current) {
            inputRef.current.focus();
            if (type !== 'number') {
                inputRef.current.select();
            }
        }
    }, [editing, type]);
    const handleBlur = () => setEditing(false);
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && type !== 'textarea') {
            setEditing(false);
        }
        if (e.key === 'Escape') {
            setEditing(false);
        }
    };
    const handleOnClick = () => {
        if (!readOnly) {
            setEditing(true);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    if (editing) {
        if (type === 'textarea') {
            return (_jsx(MarkdownEditor, { markdown: value.toString(), onChange: (markdown) => onChange({
                    target: {
                        name,
                        value: markdown,
                    },
                }), onBlur: handleBlur }));
        }
        return (_jsx("input", { ref: inputRef, name: name, type: type, value: value, placeholder: placeholder, min: min, onChange: onChange, onBlur: handleBlur, onKeyDown: handleKeyDown, className: `inline-edit-input editing ${className || ''}` }));
    }
    return (_jsx("span", { className: `inline-edit-display ${className || ''}`, onClick: handleOnClick, title: placeholder, style: type === 'textarea' ? { display: 'block', overflow: 'auto' } : {}, children: value === '' || value === undefined ? (_jsx("span", { className: "inline-edit-placeholder", children: placeholder })) : type === 'textarea' ? (_jsx(MarkdownRenderer, { value: value.toString() })) : (value.toString()) }));
};
export default InlineEditField;
